// countryApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'model/response-model';
import { WaitlistApiResponse, WaitlistModel } from 'model/waitlist-model';

export const waitlistApi = createApi({
  reducerPath: 'waitlistApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.jobpro.com/api/identity/',
    prepareHeaders: (headers: any) => {
      headers.set('subdomain', 'api')
    }
  }),
  tagTypes: ['Waitlist'],
  endpoints: (builder) => ({
    getWaitList: builder.query<WaitlistApiResponse<WaitlistModel[]>, void>({
      query: () => ({
        url: 'getwaitinglist',
      }),
    }),
  }),
});

export const { useGetWaitListQuery } = waitlistApi;